<template>
  <div :class="control.class">
    <Label v-if="control.label" :text="control.label" :for="control.uuid"
      :required="control.rules && control.rules.split('|').includes('required')" />
    <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-8">
      <div v-for="option in control.options" :key="option.value">
        <label
          class="relative flex md:flex-col items-center gap-4 md:gap-2 border border-white/10 bg-white/5 p-4 lg:p-8 rounded cursor-pointer transition duration-200 ease-in-out"
          :class="{ 'ring-2': value === option.value }" :style="{
            '--tw-ring-color': control.brand_colour ?? '#d4016d',
            borderColor: value === option.value ? (control.brand_colour ?? '#d4016d') : 'rgba(255,255,255,0.1)',
            backgroundColor: value === option.value && control.brand_colour ? '#f5f5f5' : undefined
          }">

          <component :is="option.icon" :class="{ 'text-primary': value === option.value }"
            class="md:mx-auto size-12 md:size-24 flex-grow-0"
            :style="{ stroke: value === option.value ? (control.brand_colour ?? 'currentColor') : 'currentColor' }" />

          <input v-model="value" type="radio" :name="control.name" :value="option.value"
            class="hidden h-5 w-5 transition duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-opacity-25 disabled:opacity-50 disabled:cursor-not-allowed"
            :style="{ '--tw-ring-color': control.brand_colour ?? '#d4016d' }" />

          <span>{{ option.label }}</span>

          <!-- Checked indicator -->
          <div v-if="option.value === value" class="absolute top-2 right-2 md:top-4 md:right-4 rounded-full h-6 w-6 p-1"
            :style="{ backgroundColor: control.brand_colour ?? '#d4016d' }">
            <svg class="h-4 w-4 text-navy" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="3" stroke-linecap="round">
              <path d="M20 6 9 17l-5-5" />
            </svg>
          </div>
        </label>

        <Note v-if="option.note">{{ option.note }}</Note>
      </div>
    </div>

    <Error v-if="errorMessage" :style="{ color: control.brand_colour ?? 'rgb(253 1 130 / var(--tw-text-opacity))' }">
      {{ errorMessage }}
    </Error>

    <Note v-if="control.note">{{ control.note }}</Note>
  </div>
</template>

<script setup>
import { useField } from 'vee-validate'

const props = defineProps({
  control: Object
})

const { value, errorMessage } = useField(
  props.control.name,
  props.control.rules,
  {
    label: props.control.label
  }
)
</script>
